<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :scmCode="scmCode"
      :amzMoqCode="amzMoqCode"
      :tablePage="page"
      :disabled="disabled"
      :moqMaterialDisabled="moqMaterialDisabled"
      @reload="reload"
      ref="main"
      @openEditFormDialog="openEditFormDialog"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="reload"
        @openChooseSkuDialog="openChooseSkuDialog"
      >
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          v-if="allow('B')"
          class="clearable-button"
          v-show="!disabled"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            v-if="allow('B')"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="openBatchUpdateMoq"
          >
            {{ $l('btn_batch_updated') || '批量更新' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <ChooseSkuDialog
      :visible.sync="chooseSkuDialogVisible"
      url="/ecom/amz/sku/listByChoose"
      :scmCode="scmCode"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseSkuConfirm"
    />

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="900px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.close()"
      v-el-dialog-drag
    >
      <SkuMoqMaterialDetail
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :amzSkuCode="editFormDialogOptions.code"
        :amzMoqCode="amzMoqCode"
        :moqMaterialDisabled="moqMaterialDisabled"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.close()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          v-if="!moqMaterialDisabled"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
    <BatchUpdateMoq
      :title="'批量更新'"
      v-if="batchUpdateMoqOptions.visible"
      :moqMaterialDisabled="moqMaterialDisabled"
      :amzMoqCode="amzMoqCode"
      :amzSkuCodes="amzSkuCodes"
      @close="closeBatchUpdateMoq"
    ></BatchUpdateMoq>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseSkuDialog from '../choose-amz-sku'
import SkuMoqMaterialDetail from '../sku-moq-material-detail'
import BatchUpdateMoq from '../batch-update-moq'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    ChooseSkuDialog,
    SkuMoqMaterialDetail,
    BatchUpdateMoq,
  },
  props: {
    amzMoqCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    moqMaterialDisabled: { type: Boolean, default: true },
    scmCode: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      chooseSkuDialogVisible: false,
      checkedRows: [],
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
      batchUpdateMoqOptions: {
        visible: false,
        title: '',
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
    amzSkuCodes() {
      return this.checkedRows?.map(e=>e.amzSkuCode) || []
    }
  },
  methods: {
    queryData(scmCode) {
      this.getData({ scmCode })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    openBatchUpdateMoq() {
      this.batchUpdateMoqOptions.visible = true
    },
    closeBatchUpdateMoq() {
      this.batchUpdateMoqOptions.visible = false
      this.reload()
    },
    getData(form) {
      console.log(this.scmCode)
      this.loading = true
      this.$api
        .ecomAmzSkuListByMoqApi({
          amzMoqCode: this.amzMoqCode,
          scmCode: this.scmCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    chooseSkuConfirm(data) {
      const listCode = data.map((item) => {
        return item.amzSkuCode
      })
      this.loadingOpen()

      this.$api
        .ecomAmzSkuMoqMaterialAddSkuApi({
          amzMoqCode: this.amzMoqCode,
          scmCode: this.scmCode,
          listCode: listCode,
        })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.reload()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    openChooseSkuDialog() {
      this.chooseSkuDialogVisible = true
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('dialog_title_sku_edit') || '编辑产品信息',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>